import { TBankTVRandCVRDataTableData } from "./BankTVRandCVRDataTableMeta";

const BankTVRFakeData: Omit<TBankTVRandCVRDataTableData, "cvrBitsLabel">[] = [
    {
        primaryKey: 1,
        tvrBitsLabel: "",
        bit: "",
        byte: "",
    },
    {
        primaryKey: 2,
        tvrBitsLabel: "",
        bit: "",
        byte: "",
    },
    {
        primaryKey: 3,
        tvrBitsLabel: "",
        bit: "",
        byte: "",
    }

];

const BankCVRFakeData: Omit<TBankTVRandCVRDataTableData, "tvrBitsLabel">[] = [
    {
        primaryKey: 1,
        cvrBitsLabel: "",
        bit: "",
        byte: "",
    },
    {
        primaryKey: 2,
        cvrBitsLabel: "",
        bit: "",
        byte: "",
    },
    {
        primaryKey: 3,
        cvrBitsLabel: "",
        bit: "",
        byte: "",
    }

];

export default {Terminal: BankTVRFakeData, Card: BankCVRFakeData};